import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormWrapper from "../FormWrapper";
import {
  getCommissionRuleDetailById,
  getCommissionRulesList,
} from "../../../redux/SystemManager/commissionRules";
import { useToastMessage } from "../../../components/ToastMessage/ToastMessage";
import { Toaster } from "@fluentui/react-components";
import { FormLoader } from "../../../components/Loader/FormLoader";
import { TableListLoader } from "../../../components/Loader/TableListLoader";
import ListWrapper from "../ListWrapper";
import { configFm } from "../../../types";
import { AppDispatch, RootState } from "../../../redux/store";
const FORM_CONTEXT = "COMMISSION_RULES";
const API_BASE_PATH = "/system-manager/commission/commission-rule";

function CommissionRulesDetailPage() {
  const { itemId, action } = useParams();
  const location = useLocation();
  const { showToast, toasterId } = useToastMessage();
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { activeItem, list, loading, activeItemLoading, count } = useSelector(
    (state: RootState) => state.commissionRules
  );
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const [configForm, setConfigForm] = useState<configFm>();
  const [currentRecord, setCurrentRecord] = useState(1);

  useEffect(() => {
    dispatch(
      getCommissionRulesList({
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
        search: globalFilter,
      })
    );
  }, [dispatch, pagination.pageIndex, pagination.pageSize, globalFilter]);

  useEffect(() => {
    if (list.length > 0 && itemId) {
      const itemInList = list.find((item: any) => item.id === itemId);
      if (!itemInList) {
        if (list[0]?.id) {
          dispatch(getCommissionRuleDetailById(list[0].id));
          navigate(`${API_BASE_PATH}/${list[0].id}/${action || "view"}`);
        }
      } else {
        dispatch(getCommissionRuleDetailById(itemId));
      }
    }
  }, [list, itemId, dispatch, pagination.pageSize]);

  useEffect(() => {
    if (list.length > 0 && !itemId && !action) {
      navigate(`${API_BASE_PATH}`);
    }
  }, [list, itemId, action, navigate]);
  useEffect(() => {
    if (
      formSettingsObj?.systemAdmin &&
      formSettingsObj.systemAdmin.formConfig !== undefined
    ) {
      let configObj = formSettingsObj.systemAdmin.formConfig.find(
        (item: any) => item.context === FORM_CONTEXT
      );
      if (configObj) {
        setConfigForm(configObj);
      }
    }
  }, [formSettingsObj]);

  const loadData = async (
    dispatch: AppDispatch,
    id?: string
  ): Promise<void> => {
    await dispatch(
      getCommissionRulesList({
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
        search: globalFilter,
      })
    );
    if (id) {
      await dispatch(getCommissionRuleDetailById(id));
    }
  };
  const haslist = useMemo(() => list.length > 0, [list]);
  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <div className="admin_container_flex">
        {action &&
          (activeItemLoading ? (
            <FormLoader />
          ) : (
            <FormWrapper
              dataList={list}
              context={FORM_CONTEXT}
              reloadData={loadData}
              selectedRowItem={activeItem}
              config={configForm}
              action={action || "view"}
              apiPath={API_BASE_PATH}
              notify={showToast}
              activeRow={currentRecord}
            />
          ))}

        {loading ? (
          <TableListLoader rows={8} columns={6} />
        ) : (
          haslist &&
          action &&
          list.length > 0 && (
            <ListWrapper
              data={list}
              context={FORM_CONTEXT}
              selectedRowItem={activeItem}
              pagination={pagination}
              setPagination={setPagination}
              globalFilter={globalFilter}
              onRowAction={(action, row) =>
                navigate(`${API_BASE_PATH}/${row?.id}/${action || "view"}`)
              }
              currentRecord={(index) => setCurrentRecord(index)}
              rowCount={count}
            />
          )
        )}
      </div>
    </>
  );
}

export default CommissionRulesDetailPage;
